import { format, parse } from "date-fns";
import type { MarketplaceDateFilterValue } from "@/types/api/marketplace";

export function hasCompleteDateRange(
  value?: MarketplaceDateFilterValue
): boolean {
  return Boolean(value?.start && value?.end);
}

export function formatMarketplaceDateRange(
  value?: MarketplaceDateFilterValue
): string | null {
  if (!value?.start || !value?.end) return null;

  const start = parse(value.start, "yyyy-MM-dd", new Date());
  const end = parse(value.end, "yyyy-MM-dd", new Date());

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return null;
  }

  const sameYear = start.getFullYear() === end.getFullYear();
  const startLabel = format(start, "MMM d");
  const endLabel = sameYear
    ? format(end, "MMM d")
    : format(end, "MMM d, yyyy");

  return `${startLabel} – ${endLabel}`;
}
